/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const campaignAddonProductSchema = z.enum(['Campaign Service', 'Contact Service'])

export type CampaignAddonProductSchema = z.infer<typeof campaignAddonProductSchema>
